/**
 * De datum van één ingevulde vragenlijst: het vroegste antwoord in de reeks.
 *
 * Een inzending schrijft per vraag een eigen antwoorddocument weg; die krijgen
 * niet allemaal exact dezelfde tijdstempel. Het vroegste antwoord is dus het
 * moment waarop de respondent begon.
 *
 * @param {Array<object>} responses - QuestionnairesResponses van één inzending.
 * @returns {Date | null} Het moment van inzending, of null als er (nog) geen
 *   antwoord met een bruikbare tijdstempel is.
 */
const submissionDate = (responses) => {
    const times = (Array.isArray(responses) ? responses : [])
        .map((response) => response?.Timestamp?.toDate?.())
        .filter(Boolean)
        .map((date) => date.getTime());

    return times.length ? new Date(Math.min(...times)) : null;
};

export default submissionDate;
